<template>
  <a class="tdNone phone" :href="`tel:${phone}`">
    {{ phone }}
  </a>
</template>
<script>
  export default {
    props: ["phone"],
  };
</script>
<style scoped>
  .phone:hover {
    color: #229;
  }
</style>
